export * from '@primeuix/themes/lara/imagecompare';
export { default } from '@primeuix/themes/lara/imagecompare';
